import { useState } from "react";
import { ActionMenuItem } from "../../../../components/actionMenu/ActionMenu";
import { useAppSelector } from "../../../../redux/hooks";
import { RecallClientActionsDataInterface } from "../../../../redux/interfaces/recall.interface";
import { isRecallAwbSent } from "./recallClientActionsHelper";

function useRecallClientAwbPrintAction({
  client,
}: {
  client: RecallClientActionsDataInterface;
}) {
  const [showModal, setShowModal] = useState(false);
  const isPrinting = useAppSelector((state) => state.recall.awbPrint.isLoading);
  const isEntryUnavailable = useAppSelector(
    (state) => state.recall.entry.isLoading || state.recall.entry.isError,
  );
  const isBatchLoading = useAppSelector(
    (state) => state.recall.clientBatch.isLoading,
  );
  const hasPendingClientActions = useAppSelector(
    (state) => state.recall.pendingClientActionIds.length > 0,
  );
  const hasPrintableAwb =
    isRecallAwbSent(client.awb) || isRecallAwbSent(client.awb?.returnAwb);
  const disabledReason = !hasPrintableAwb
    ? "Nu exista AWB-uri generate pentru imprimare."
    : isPrinting
    ? "Imprimarea AWB-urilor este in curs."
    : isEntryUnavailable
    ? "Datele retragerii trebuie incarcate cu succes inainte de imprimare."
    : isBatchLoading || hasPendingClientActions
    ? "Asteapta finalizarea actiunii in curs pentru farmacii."
    : "";

  const action: ActionMenuItem = {
    id: "print-awb",
    label: "Imprima AWB",
    icon: "DOCUMENTS",
    kind: "print",
    tooltip:
      disabledReason ||
      "Alege AWB-ul de plic, retur sau ambele si trimite etichetele la imprimanta.",
    disabled: Boolean(disabledReason),
    loading: showModal && isPrinting,
    onClick: () => setShowModal(true),
  };

  return { action, showModal, handleClose: () => setShowModal(false) };
}

export default useRecallClientAwbPrintAction;
